import {DodgerBlueColor} from '../../cmsMainStyle'

const drawingFileZoneContentStyle = theme => ({



	fieldDivision: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 320),
		overflowY: "auto",
		overflowX: "hidden",
	},

	addFileBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},

		marginTop: theme.spacing(1),
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},


	messageAttachmentArea: {
		'& > *': {
			margin: theme.spacing(0.5),
		  },

		  display: "flex",
		  flexWrap: "wrap",
		  flexDirection: "row",
	},

	fileList: {
		marginTop: theme.spacing(2),
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3),
	},

	attachmentBtn: {
		margin: "2px",
	},

	approveText: {
		'& .MuiTextField-root': {
			marginBottom: theme.spacing(1),
		},

		marginLeft: theme.spacing(8),
	},

	approveTextDivider: {
		marginTop: theme.spacing(2),
	},


	fileUploadBtnArea: {
		textAlign: "center",
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},

	fileUploadBtn: {
		backgroundColor: DodgerBlueColor[11],
	}




})

export {drawingFileZoneContentStyle}